module.exports = __webpack_public_path__ + "static/media/bytt-nn-11.8f12234d.mp3";